import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { AutoCompleteSelectionItem, IAutoCompleteService } from '../../../core/component/autocomplete-remote/autocomplete-remote.component';
import { DataService, toModel } from '../../../core/service/base/data.service';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { Account } from '../../model/account';

function toAccount(accountLike: Account): Account {
  return toModel(Account, accountLike);
}

function toAutoCompleteAccountItem(accountLike: Account): AutoCompleteSelectionItem<Account> {
  const account = toAccount(accountLike);
  let caption = account.toString();
  return new AutoCompleteSelectionItem(caption, account.id, account, caption);
}

@Injectable()
export class AccountingAccountService extends DataService<Account> implements IAutoCompleteService<Account, string> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, Account, progressBar, 'accounting-account');
  }

  getSelectionItem(id: string): Observable<AutoCompleteSelectionItem<Account>> {
    return this.client.get<Account>(`${this.endpoint}/selectionItem/${id}`).pipe(
      map(toAutoCompleteAccountItem),
      catchError(e => {
        this.notification.showError(e);
        return [];
      })
    );
  }

  // 'options' is accountPlanId
  getSelection(filter: string, options?: string, page?: number): Observable<AutoCompleteSelectionItem<Account>[]> {
    const queryArgs = {
      filter: filter,
      maxItems: 20,
    };
    if (options) queryArgs['options'] = options;
    if (page > 0) queryArgs['page'] = page;

    return this.client.post<Account[]>(`${this.endpoint}/selection`, queryArgs).pipe(
      map(data => data.map(toAutoCompleteAccountItem)),
      catchError(e => {
        this.notification.showError(e);
        throw e;
      })
    );
  }
}
